import { useState, useRef, useLayoutEffect, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import ImgPrimaveraOne from '../../images/primaveraOne.png';


import {
  Carousel,
  PrimaveraOne,
    WrapperCard,
    CarouselCard,
    ImgSlider,
    Overlay,
    ArrowRight,
    ArrowLeft,
    Button,
    ScrollDownButton,
    ScrollArrow
} from './SliderElements';

const AUTO_PLAY_INTERVAL = 4000; // tempo em ms


const Slider = ({images}) => {
  const [current, setCurrent] = useState(0);
  const ref = useRef(null);
  const intervalRef = useRef()
  const scrollBtnRef = useRef(null); // ref para o botão

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.to(".carousel_wrapper", {
        opacity: 1,
        scrollTrigger:{
            trigger: ".card_img",
            start: "top 70%",
            end: "bottom 99%",
            scrub: true,

        }
    })

    ScrollTrigger.refresh();
    return() => {
        gsap.killTweensOf("#primavera");
    }
}, [])

  // animação pulse / up-down do botão
  useEffect(() => {
    if (!scrollBtnRef.current) return;
    const tl = gsap.timeline({ repeat: -1, yoyo: true });
    tl.to(scrollBtnRef.current, { y: -8, duration: 0.9, ease: 'power1.inOut' }, 0);
    tl.to(scrollBtnRef.current, { scale: 1.06, duration: 0.9, ease: 'sine.inOut' }, 0);
    return () => tl.kill();
  }, []);

  const handleScrollToCardapio = () => {
    // duration em segundos; offsetY em px (ajuste conforme seu header)
    gsap.to(window, { duration: 0.8, scrollTo: { y: '#cardapio', offsetY: 80 }, ease: 'power2.inOut' });
  }

useLayoutEffect(() => {
        ScrollTrigger.refresh();
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".imgOne", {
            x: 0,
            opacity: 1,
            scale: 1.3,
            right: -20,
            scrollTrigger:{
                trigger: "#primavera",
                start: "top bottom+=250",
                end: "top 150px",
                scrub: true,
                pinSpacing: false,
            }
        })
        return() => {
            gsap.killTweensOf(".imgOne");
        }
    }, [])

  // AUTOPLAY
  const startAutoplay = () => {
  clearInterval(intervalRef.current);
  intervalRef.current = setInterval(() => {
    setCurrent(prev => prev === images.length - 1 ? 0 : prev + 1);
  }, AUTO_PLAY_INTERVAL);
};

useEffect(() => {
  startAutoplay();
  return () => clearInterval(intervalRef.current);
}, [images.length]);

const goToSlide = (idx) => {
  setCurrent(idx);
  startAutoplay(); // reinicia o autoplay ao clicar
};



  return (
    <div id='primavera' ref={ref} style={{position: 'relative', flex: 1, overflow: 'visible'}}>
      <PrimaveraOne className='imgOne' src={ImgPrimaveraOne} />
      
        {/* botão sobreposto entre slider e próximo bloco */}
        <ScrollDownButton
          ref={scrollBtnRef}
          onClick={handleScrollToCardapio}
          aria-label="Ir para o cardápio"
          title="Ir para o cardápio"
        >
          <ScrollArrow viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 16.5l-6-6 1.4-1.4L11 12.7V4h2v8.7l3.6-3.6L18 10.5z"/>
          </ScrollArrow>
        </ScrollDownButton>

    <Carousel id='fotos' className='carousel'>
      <div className='schadule_card'
            style={{
                display: "flex",
                width: "100%",
                height: "100%",
                flexDirection: "column",
                alignItems: "stretch", // ou "center" se quiser centralizar, mas "stretch" garante 100% largura dos filhos
                justifyContent: "stretch", // garante altura total
                flexGrow: 1,
                overflow: "visible",
            }}
        >
        <WrapperCard className='carousel_wrapper'>
            {images.map((image, index) => {
              return(
              <CarouselCard key={index} className={index === current 
              ? "carousel_card_active" 
              : "carousel_card"
              }
              >
                <ImgSlider className='card_img' src={image.image} style={{ objectPosition: image.position || "100%" }} />
                <Overlay className='card_overlay'>
                  <h2 className='card_title'>
                    {image.title}
                  </h2>

                </Overlay>
                {/* <Button className='arrowRight' onClick={slideRight}>{<ArrowRight />}</Button> */}
                {/* <Button className='arrowLeft' onClick={slideLeft}>{<ArrowLeft />}</Button> */}
              </CarouselCard>
              )
              

            })}

        </WrapperCard>

        {/* Miniaturas */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 12,
            margin: '24px 0 0 0',
            position: 'absolute',
            alignSelf: 'center',
            bottom: 30,
          }}
        >
          {images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => goToSlide(idx)}
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                border: idx === current ? '2px solid #E38339' : '1px solid #ccc',
                padding: 0,
                overflow: 'hidden',
                outline: 'none',
                background: idx === current ? '#FDDFC7' : '#fff',
                cursor: 'pointer',
                boxShadow: idx === current ? '0 0 6px #E38339' : 'none',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              aria-label={`Ir para imagem ${idx + 1}`}
            >
              <img
                src={img.image}
                alt={img.title || `Miniatura ${idx + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  opacity: idx === current ? 1 : 0.7,
                  transition: 'opacity 0.2s'
                }}
              />
            </button>
          ))}
        </div>
        </div>
    </Carousel>
    </div>

  )
}

export default Slider
